import { useQuery } from '@tanstack/react-query'
import { fetchDivineVideo } from '@/services/divineService'
import type { DivineVideoMeta } from '@/services/divineService'

export type { DivineVideoMeta }

/**
 * Fetches metadata for a Divine.video Nostr event ID.
 * Nostr events are immutable — staleTime is Infinity to skip background refetches.
 * retry:false so 404 / relay-miss errors fail immediately without hammering the server.
 */
export function useDivineVideo(eventId: string) {
    return useQuery<DivineVideoMeta>({
        queryKey: ['divineVideo', eventId],
        queryFn: () => fetchDivineVideo(eventId),
        staleTime: Infinity,
        retry: false,
        enabled: !!eventId,
    })
}
